import React from 'react';
import { useLocation, useNavigate, Routes, Route, Outlet, useMatch, useParams } from "react-router-dom";
import { useRef, useState } from 'react';
import AboutMercy from "./AboutMercy";
import MainOutlet from "./MainOutlet";
import Home from "./Home";
import ShareLearning from './ShareLearning';
import Appointment from './Appointment';
import Environment from './Environment';
import AdminHome from "./Admin_Home";
import Teachers from "./Teachers";
import Class from "./Class";
import ClassIntroduce from "./ClassIntroduce";
import TuitionFeeHome from "./TuitionFeeHome";
import Sidebar from "./components/SideBar";
import LessonList from "./LessonList";
import StudentList from "./StudentList";
import RFIDRollCall from "./RFIDRollCall";
import Manage from "./Manage";
import AdminClass from "./AdminClass";
import SearchStudentList from "./SearchStudentList";
import AdminEnviorment from "./AdminEnviornment";
import AdministrationList from "./AdministrationList";
import TeacherList from './TeacherList';
import EnviornmentList from './EnviornmentList';
import GradeList from './GradeList';
import News from './News';
import ClassIntroduceContent from './components/ClassIntroduceContent';
import AdminNews from './AdminNews';
import AdminTeacher from './AdminTeacher';
import AdminTidbits from './AdminTidbits';
import ClassList from './ClassList';
import ChatRoom from './ChatRoom';
import LessonCategoryList from './LessonCategoryList';
import Enroll from './Enroll';
import Maintain from './Maintain';
import PermissionsList from './PermissionList';
import ClassTab from './components/ClassTab';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/es/locale/zh_TW';
import AdminShareLearning from './AdminShareLearning';
import Main_layout from './components/Main_layout';
import ClassRoomList from './ClassRoomList';
import AdminAppointment from './AdminAppointment';
import FeedbackForm from './FeedbackForm';
import FeedBackTab from './components/FeedbackTab';
import FeedbackFormList from './FeedbackFormList';
import PositionList from './PositionList';
import AdminMedia from './AdminMedia';
import AdminMediaContent from './components/AdminMediaContent';
import AdminMediaTab from './components/AdminMediaTab';
import AdminCourseOutline from './AdminCourseOutline';
import AdminCourseTab from './components/AdminCourseTab';
import AdminCourseList from './AdminCourseList';
import AdminCourseOutlineManage from './AdminCourseOutlineManage';
import AdminMakeUpCourseManage from './AdminMakeUpCourseManage';
import AdminCourseMaterial from './AdminCourseMaterial';
import axios from 'axios';
import { useEffect } from 'react';
import AdminCourseStudentOverview from './AdminCourseStudentOverview';
import AdminCourseStudentAttendance from './AdminCourseStudentAttendance';
import AdminTeacherCourseManage from './AdminTeacherCourseManage';
import StudentEnroll from './StudentEnroll';
import MediaContent from './MediaContent';
import LessonConent from './components/LessonContent';
import AdminClassScheduling from './AdminClassScheduling';
import VideoWatch from './VideoWatch';
import TagList from './TagList';
import AdminClassEncoding from './AdminClassEncoding';
import NewCourse from './NewCourse';
import TuitionFeeDetail from './TutionFeeDetail';
import AddTuitionFee from './AddTuitionFee';
import AdminCourseStudentAttendanceOverview from './AdminCourseStudentAttendanceOverview';
import AdminClassTime from './AdminClassTime';
import MediaSmartphone from './components/Media/MediaSmartPhone';
import ClassTuitionFeeDetail from './ClassTuitionFeeDetail';
import PunchReservation from '../punch_in_and_out/PunchReservation';
import PunchOut from '../punch_in_and_out/PunchOut';
import QRcodePunch from '../punch_in_and_out/QRcodePunch';
import LocationData from '../punch_in_and_out/LocationData';
import AdminStudentTuition from './components/AdminStudentTuition';
import AdminLessonTuitionOverview from './AdminLessonTuitionOverview';
import BillPaymentClassOverview from './components/Tuition/view/BillPaymentClassOverview';
import ConfirmTuitionFeeOverView from './components/ConfirmTuitionFee/View/ConfirmTuitionFeeOverView';
import ConfirmTuitionFeeStudentDetailOverView from './components/ConfirmTuitionFee/View/ConfirmTuitionFeeStudentDetailOverView';
import SystemHolidayOverView from './components/SystemHoliday/views/SystemHolidayOverView';
import SystemHolidayDetailOverView from './components/SystemHoliday/views/SystemHolidayDetailOverView';
import StudentCheckInOverView from './components/StudentCheckIn/View/StudentCheckInOverView';
import StudentCheckInDetailOverView from './components/StudentCheckIn/View/StudentCheckInDetailOverView';
import NotifyBind from '../login/NotifyBind';
import PunchOverview from './components/PunchManagement/view/PunchOverview';
import PunchRecode from './components/PunchManagement/view/PunchRecode';
import ClassStudentPunchDetail from './components/PunchManagement/view/ClassStudentPunchDetail';
import ProtalMainPage from './components/protal/view/ProtalMainPage';
import EmergencyContactList from './components/EmergencyContact/views/EmergencyContactList'
import ChildrenBinding from './ChildrenBinding';
import ClassTimeSetting from './components/PunchManagement/view/ClassTimeSetting'

const MainRoute = ({
    admin
}) => {
    const jwt = admin ? {
        element: <JWT />
    } : {}
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: 'rgb(83, 183, 173)',
                },
            }}
            locale={zhTW}>
            <Routes>
                <Route path={''} {...jwt}>
                    <Route path={''} element={<MainOutlet />}>
                        <Route index element={<Home />} ></Route>
                        <Route path={'News'} element={<News />} ></Route>
                        <Route path={'News/:Id'} element={<ClassIntroduceContent />} ></Route>
                        <Route path={'ShareLearning'} element={<ShareLearning />} ></Route>
                        <Route path={'ShareLearning/:Id'} element={<ClassIntroduceContent />} ></Route>
                        <Route path={'AboutMercy'} element={<AboutMercy />} ></Route>
                        <Route path={'VideoWatch'} element={<VideoWatch />} ></Route>
                        <Route path={'Appointment'} element={<Appointment />} ></Route>
                        <Route path={'Environment'} element={<Environment />} ></Route>
                        <Route path={'Teachers'} element={<Teachers />} ></Route>
                        <Route path={'Class'} element={<Class />} ></Route>
                        <Route path={'Class/:Id'} element={<ClassIntroduceContent />} ></Route>
                        <Route path={'ClassIntroduce'} element={<ClassIntroduce />} ></Route>
                        <Route path={'Lesson/:Id'} element={<LessonConent />} ></Route>
                        <Route path={'NewCourse'} element={<NewCourse />} ></Route>
                        <Route path={'ClassIntroduce/:Id'} element={<ClassIntroduceContent />} ></Route>
                        <Route path={'ClassIntroduce/:Id/:lesson_id'} element={<ClassIntroduceContent />} ></Route>
                        <Route path={'Enroll'} element={<Enroll />} ></Route>
                        <Route path={'StudentEnroll/:Id'} element={<StudentEnroll />} ></Route>
                        {/* <Route path={'Manage'} element={<Manage />} ></Route> */}
                    </Route>
                </Route>
                {admin && (<>
                    <Route path={''} element={<JWT />}>
                        <Route path={'punchInAndOut'}>
                            <Route path={'ChildrenBinding/:StudentId'} element={<ChildrenBinding />} />
                        </Route>
                        <Route path={''} element={<BackendPermissionLimit />}> {/* 權限阻擋*/}
                            <Route path="admin" element={<Sidebar topic={'admin'} />} >
                                <Route index element={<Main_layout
                                    path={[{ name: '即時總覽', path: '' }]} >
                                    <ProtalMainPage />
                                </Main_layout >} />
                                <Route path='StudentList'
                                    element={<Main_layout
                                        path={[
                                            { name: '基本資料管理', path: '' },
                                            // { name: '基本資料維護', path: '' },
                                            // { name: '學生基本資料維護', path: '' },
                                            { name: '學員名單', path: '' }
                                        ]}
                                    >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/StudentList': '學員名單',
                                                // '/cramSchool/admin/EmergencyContactList': '緊急聯絡人名單',
                                                // '/cramSchool/admin/SearchStudentList': '諮詢名單',
                                                // '/cramSchool/admin/GradeList': '年級管理',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/StudentList",
                                                    label: `學員名單`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/EmergencyContactList",
                                                //     label: `緊急聯絡人名單`,
                                                // },
                                                // {
                                                //     key: "/cramSchool/admin/SearchStudentList",
                                                //     label: '諮詢名單',
                                                // },
                                                // {
                                                //     key: "/cramSchool/admin/GradeList",
                                                //     label: `年級管理`,
                                                // },
                                            ]} />
                                        <StudentList />
                                    </Main_layout >} />
                                {/* <Route path='EmergencyContactList'
                                    element={<Main_layout
                                        path={[
                                            { name: '開課前', path: '' },
                                            { name: '基本資料維護', path: '' },
                                            { name: '學生基本資料維護', path: '' },
                                            { name: '緊急聯絡人名單', path: '' }
                                        ]}
                                    >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/EmergencyContactList': '緊急聯絡人名單',
                                                '/cramSchool/admin/StudentList': '學員名單',
                                                '/cramSchool/admin/SearchStudentList': '諮詢名單',
                                                '/cramSchool/admin/GradeList': '年級管理',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/StudentList",
                                                    label: `學員名單`,
                                                },
                                                {
                                                    key: "/cramSchool/admin/EmergencyContactList",
                                                    label: `緊急聯絡人名單`,
                                                },
                                                {
                                                    key: "/cramSchool/admin/SearchStudentList",
                                                    label: '諮詢名單',
                                                },
                                                {
                                                    key: "/cramSchool/admin/GradeList",
                                                    label: `年級管理`,
                                                },
                                            ]} />
                                        <EmergencyContactList />
                                    </Main_layout >} />
                                <Route path='SearchStudentList' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '基本資料維護', path: '' },
                                    { name: '學生基本資料維護', path: '' },
                                    { name: '諮詢名單', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/StudentList': '學員名單',
                                            '/cramSchool/admin/SearchStudentList': '諮詢名單',
                                            '/cramSchool/admin/GradeList': '年級管理',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/StudentList",
                                                label: `學員名單`,
                                            },
                                            {
                                                key: "/cramSchool/admin/EmergencyContactList",
                                                label: `緊急聯絡人名單`,
                                            },
                                            {
                                                key: "/cramSchool/admin/SearchStudentList",
                                                label: '諮詢名單',
                                            },
                                            {
                                                key: "/cramSchool/admin/GradeList",
                                                label: `年級管理`,
                                            },
                                        ]} />
                                    <SearchStudentList />
                                </Main_layout >} />
                                <Route path='GradeList' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '基本資料維護', path: '' },
                                    { name: '學生基本資料維護', path: '' },
                                    { name: '年級管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/StudentList': '學員名單',
                                            '/cramSchool/admin/SearchStudentList': '諮詢名單',
                                            '/cramSchool/admin/GradeList': '年級管理',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/StudentList",
                                                label: `學員名單`,
                                            },
                                            {
                                                key: "/cramSchool/admin/EmergencyContactList",
                                                label: `緊急聯絡人名單`,
                                            },
                                            {
                                                key: "/cramSchool/admin/SearchStudentList",
                                                label: '諮詢名單',
                                            },
                                            {
                                                key: "/cramSchool/admin/GradeList",
                                                label: `年級管理`,
                                            },
                                        ]} />
                                    <GradeList />
                                </Main_layout >} />
                                <Route path='AdminLessonTuitionOverview'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/AdminLessonTuitionOverview': "繳費單總覽",
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },

                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },

                                            ]} />
                                        <BillPaymentClassOverview />
                                    </Main_layout >} />
                                <Route path='TuitionFee' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '建立繳費單', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TuitionFee': '學費總覽',
                                            '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                            // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                            '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                            '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                label: `班級繳費項目總覽`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/TuitionFee",
                                            //     label: `學費總覽`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/TuitionFeeDetail",
                                                label: '收費明細管理',
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassTuitionFeeDetail",
                                            //     label: '班級收費明細管理',
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/AddTuitionFee",
                                            //     label: `建立繳費單`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/ConfirmTuitionFee",
                                                label: '繳費確認',
                                            },

                                        ]} />
                                    <TuitionFeeHome />
                                </Main_layout >} />
                                <Route path='TuitionFeeDetail'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },

                                            ]} />
                                        <TuitionFeeDetail />
                                    </Main_layout >} />
                                <Route path='ConfirmTuitionFee'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                                '/cramSchool/admin/ConfirmTuitionFee': '繳費確認',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },
                                            ]} />
                                        <ConfirmTuitionFeeOverView />
                                    </Main_layout >} />
                                <Route path='ConfirmTuitionFeeStudentDetail/:bill_payment_id'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                                '/cramSchool/admin/ConfirmTuitionFee': '繳費確認',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },
                                            ]} />
                                        <ConfirmTuitionFeeStudentDetailOverView />
                                    </Main_layout >} /> */}
                                <Route path='SystemHolidayOverView'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                                '/cramSchool/admin/ConfirmTuitionFee': '繳費確認',
                                                '/cramSchool/admin/SystemHolidayOverView': '繳費確認',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },
                                            ]} />
                                        <SystemHolidayOverView />
                                    </Main_layout >} />
                                <Route path='SystemHolidayDetailOverView/:holiday_setting_id'
                                    element={<Main_layout
                                        path={
                                            [{ name: '開課前', path: '' },
                                            { name: '學費系統管理', path: '' },
                                            { name: '建立繳費單', path: '' }]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/TuitionFee': '學費總覽',
                                                '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                                // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                                '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                                '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                                '/cramSchool/admin/ConfirmTuitionFee': '繳費確認',
                                                '/cramSchool/admin/SystemHolidayOverView': '繳費確認',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                    label: `班級繳費項目總覽`,
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/TuitionFee",
                                                //     label: `學費總覽`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/TuitionFeeDetail",
                                                    label: '收費明細管理',
                                                },
                                                // {
                                                //     key: "/cramSchool/admin/AddTuitionFee",
                                                //     label: `建立繳費單`,
                                                // },
                                                {
                                                    key: "/cramSchool/admin/ConfirmTuitionFee",
                                                    label: '繳費確認',
                                                },
                                                {
                                                    key: '/cramSchool/admin/SystemHolidayOverView',
                                                    label: '國定假日/放假日設定',
                                                },
                                            ]} />
                                        <SystemHolidayDetailOverView />
                                    </Main_layout >} />
                                <Route path='AddTuitionFee' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '建立繳費單', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TuitionFee': '學費總覽',
                                            '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                            // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                            '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                            '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                label: `班級繳費項目總覽`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/TuitionFee",
                                            //     label: `學費總覽`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/TuitionFeeDetail",
                                                label: '收費明細管理',
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassTuitionFeeDetail",
                                            //     label: '班級收費明細管理',
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/AddTuitionFee",
                                            //     label: `建立繳費單`,
                                            // },

                                        ]} />
                                    <AddTuitionFee />
                                </Main_layout >} />
                                <Route path='AdminStudentTuition/:bill_payment_grade_class_id' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '建立繳費單', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TuitionFee': '學費總覽',
                                            '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                            // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                            '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                            '/cramSchool/admin/AdminStudentTuition': '班級繳費單',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                label: `班級繳費項目總覽`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/TuitionFee",
                                            //     label: `學費總覽`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/TuitionFeeDetail",
                                                label: '收費明細管理',
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassTuitionFeeDetail",
                                            //     label: '班級收費明細管理',
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/AddTuitionFee",
                                            //     label: `建立繳費單`,
                                            // },
                                            {
                                                key: '/cramSchool/admin/AdminStudentTuition/:bill_payment_grade_class_id',
                                                label: `班級繳費單`,
                                            },
                                        ]} />
                                    <AdminStudentTuition />
                                </Main_layout >} />
                                <Route path='ClassTuitionFeeDetail/:Id' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '班級收費明細管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TuitionFee': '學費總覽',
                                            '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                            // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                            '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                                label: `班級繳費項目總覽`,
                                            },
                                            {
                                                key: "/cramSchool/admin/TuitionFee",
                                                label: `學費總覽`,
                                            },
                                            {
                                                key: "/cramSchool/admin/TuitionFeeDetail",
                                                label: '收費明細管理',
                                            },

                                        ]} />
                                    <ClassTuitionFeeDetail />
                                </Main_layout >} />
                                <Route path='ClassTuitionFeeDetail' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '班級收費明細管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TuitionFee': '學費總覽',
                                            '/cramSchool/admin/TuitionFeeDetail': '收費明細管理',
                                            // '/cramSchool/admin/ClassTuitionFeeDetail': '班級收費明細管理',
                                            '/cramSchool/admin/AddTuitionFee': '建立繳費單',
                                        }}
                                        items={[

                                            {
                                                key: "/cramSchool/admin/TuitionFee",
                                                label: `學費總覽`,
                                            },
                                            {
                                                key: "/cramSchool/admin/TuitionFeeDetail",
                                                label: '收費明細管理',
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassTuitionFeeDetail",
                                            //     label: '班級收費明細管理',
                                            // },
                                            {
                                                key: "/cramSchool/admin/AddTuitionFee",
                                                label: `建立繳費單`,
                                            },
                                        ]} />
                                    <ClassTuitionFeeDetail />
                                </Main_layout >} />
                                <Route path='LessonList' element={<Main_layout
                                    path={[
                                        // { name: '開課前', path: '' },
                                        // { name: '基本資料維護', path: '' },
                                        // { name: '課程基本資料維護', path: '' },
                                        { name: '基本資料管理', path: '' },
                                        { name: '課程基本資料管理', path: '' }
                                        ]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
                                            '/cramSchool/admin/LessonList': '課程基本資料管理',
                                            // '/cramSchool/admin/ClassList': '班級基本資料管理',
                                            // '/cramSchool/admin/ClassEncoding': '班級課程編碼管理',
                                            '/cramSchool/admin/ClassTime': '授課時間管理'
                                        }}
                                        items={[
                                            // {
                                            //     key: "/cramSchool/admin/ClassList",
                                            //     label: `班級基本資料管理`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/LessonList",
                                                label: '課程基本資料管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonCategoryList",
                                                label: `課程分類基本資料管理`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassEncoding",
                                            //     label: '班級課程編碼管理',
                                            // },
                                            {
                                                key: "/cramSchool/admin/ClassTime",
                                                label: '授課時間管理',
                                            },
                                        ]} />
                                    <LessonList />
                                </Main_layout >} />
                                <Route path='LessonCategoryList' element={<Main_layout
                                    path={[
                                        //     { name: '開課前', path: '' },
                                        // { name: '基本資料維護', path: '' },
                                        // { name: '課程基本資料維護', path: '' },
                                        { name: '基本資料管理', path: '' },
                                        { name: '課程分類基本資料管理', path: '' }
                                        ]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
                                            '/cramSchool/admin/LessonList': '課程基本資料管理',
                                            // '/cramSchool/admin/ClassList': '班級基本資料管理',
                                            // '/cramSchool/admin/ClassEncoding': '班級課程編碼管理',
                                            '/cramSchool/admin/ClassTime': '授課時間管理'
                                        }}
                                        items={[
                                            // {
                                            //     key: "/cramSchool/admin/ClassList",
                                            //     label: `班級基本資料管理`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/LessonList",
                                                label: '課程基本資料管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonCategoryList",
                                                label: `課程分類基本資料管理`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassEncoding",
                                            //     label: '班級課程編碼管理',
                                            // },
                                            {
                                                key: "/cramSchool/admin/ClassTime",
                                                label: '授課時間管理',
                                            },
                                        ]} />
                                    <LessonCategoryList />
                                </Main_layout >} />
                                {/* <Route path='ClassEncoding' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '基本資料維護', path: '' },
                                        { name: '課程基本資料維護', path: '' },
                                        { name: '班級課程編碼管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
                                            '/cramSchool/admin/LessonList': '課程基本資料管理',
                                            '/cramSchool/admin/ClassList': '班級基本資料管理',
                                            '/cramSchool/admin/ClassEncoding': '班級課程編碼管理',
                                            '/cramSchool/admin/ClassTime': '授課時間管理'
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/ClassList",
                                                label: `班級基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonList",
                                                label: '課程基本資料管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonCategoryList",
                                                label: `課程分類基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/ClassEncoding",
                                                label: '班級課程編碼管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/ClassTime",
                                                label: '授課時間管理',
                                            },
                                        ]} />
                                    <AdminClassEncoding />
                                </Main_layout >} /> */}
                                <Route path='StudentCheckIn' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '基本資料維護', path: '' },
                                        { name: '課程基本資料維護', path: '' },
                                        { name: '班級課程編碼管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/StudentCheckIn': '學生打卡管理'
                                        }}
                                        items={[
                                            // {
                                            //     key: "/cramSchool/admin/ClassList",
                                            //     label: `班級基本資料管理`,
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/LessonList",
                                            //     label: '課程基本資料管理',
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/LessonCategoryList",
                                            //     label: `課程分類基本資料管理`,
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/ClassEncoding",
                                            //     label: '班級課程編碼管理',
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/ClassTime",
                                            //     label: '授課時間管理',
                                            // },
                                        ]} />
                                    <StudentCheckInOverView />
                                </Main_layout >} />
                                <Route path='StudentCheckInDetail/:Id' element={<Main_layout
                                    path={
                                        [{ name: '開課前', path: '' },
                                        { name: '學費系統管理', path: '' },
                                        { name: '班級收費明細管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/StudentCheckIn': '學生打卡管理'
                                        }}
                                        items={[
                                            // {
                                            //     key: "/cramSchool/admin/AdminLessonTuitionOverview",
                                            //     label: `班級繳費項目總覽`,
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/TuitionFee",
                                            //     label: `學費總覽`,
                                            // },
                                            // {
                                            //     key: "/cramSchool/admin/TuitionFeeDetail",
                                            //     label: '收費明細管理',
                                            // },

                                        ]} />
                                    <StudentCheckInDetailOverView />
                                </Main_layout >} />
                                <Route path='ClassTime' element={<Main_layout
                                    path={[
                                        // { name: '開課前', path: '' },
                                        // { name: '基本資料維護', path: '' },
                                        // { name: '課程基本資料維護', path: '' },
                                        { name: '基本資料管理', path: '' },
                                        { name: '授課時間管理', path: '' }
                                    ]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
                                            '/cramSchool/admin/LessonList': '課程基本資料管理',
                                            // '/cramSchool/admin/ClassList': '班級基本資料管理',
                                            // '/cramSchool/admin/ClassEncoding': '班級課程編碼管理',
                                            '/cramSchool/admin/ClassTime': '授課時間管理'
                                        }}
                                        items={[
                                            // {
                                            //     key: "/cramSchool/admin/ClassList",
                                            //     label: `班級基本資料管理`,
                                            // },
                                            {
                                                key: "/cramSchool/admin/LessonList",
                                                label: '課程基本資料管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonCategoryList",
                                                label: `課程分類基本資料管理`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassEncoding",
                                            //     label: '班級課程編碼管理',
                                            // },
                                            {
                                                key: "/cramSchool/admin/ClassTime",
                                                label: '授課時間管理',
                                            },
                                        ]} />
                                    <AdminClassTime />
                                </Main_layout >} />
                                {/* <Route path='ClassList' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '基本資料維護', path: '' },
                                    { name: '課程基本資料維護', path: '' },
                                    { name: '班級基本資料管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/LessonCategoryList': '課程分類基本資料管理',
                                            '/cramSchool/admin/LessonList': '課程基本資料管理',
                                            '/cramSchool/admin/ClassList': '班級基本資料管理',
                                            '/cramSchool/admin/ClassEncoding': '班級課程編碼管理',
                                            '/cramSchool/admin/ClassTime': '授課時間管理'
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/ClassList",
                                                label: `班級基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonList",
                                                label: '課程基本資料管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/LessonCategoryList",
                                                label: `課程分類基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/ClassEncoding",
                                                label: '班級課程編碼管理',
                                            },
                                            {
                                                key: "/cramSchool/admin/ClassTime",
                                                label: '授課時間管理',
                                            },
                                        ]} />
                                    <ClassList />
                                </Main_layout >} /> */}
                                {/* <Route path='AddStudentList' element={<AddStudentList />} /> */}
                                <Route path='RFIDRollCall' element={<RFIDRollCall />} />
                                <Route path='TeacherList' element={<Main_layout
                                    path={[
                                        { name: '基本資料管理', path: '' },
                                        // { name: '行政管理設定', path: '' },
                                        // { name: '員工基本資料管理', path: '' },
                                        { name: '師資基本資料管理', path: '' }
                                        ]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TeacherList': '師資基本資料管理',
                                            '/cramSchool/admin/AdministrationList': '行政人員基本資料管理',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/TeacherList",
                                                label: `師資基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/AdministrationList",
                                                label: '行政人員基本資料管理',
                                            },
                                        ]} />
                                    <TeacherList />
                                </Main_layout >} />
                                <Route path='AdministrationList' element={<Main_layout
                                    path={[
                                        { name: '基本資料管理', path: '' },
                                        // { name: '行政管理設定', path: '' },
                                        // { name: '員工基本資料管理', path: '' },
                                        { name: '行政人員基本資料管理', path: '' }
                                    ]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TeacherList': '師資基本資料管理',
                                            '/cramSchool/admin/AdministrationList': '行政人員基本資料管理',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/TeacherList",
                                                label: `師資基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/AdministrationList",
                                                label: '行政人員基本資料管理',
                                            },
                                        ]} />
                                    <AdministrationList />
                                </Main_layout >} />
                                <Route path='PositionList' element={<Main_layout
                                    path={[{ name: '行政管理設定', path: '' },
                                    { name: '員工基本資料管理', path: '' },
                                    { name: '職位管理', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/TeacherList': '師資基本資料管理',
                                            '/cramSchool/admin/AdministrationList': '行政人員基本資料管理',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/TeacherList",
                                                label: `師資基本資料管理`,
                                            },
                                            {
                                                key: "/cramSchool/admin/AdministrationList",
                                                label: '行政人員基本資料管理',
                                            },
                                        ]} />
                                    <PositionList />
                                </Main_layout >} />
                                <Route path='ClassRoomList' element={<Main_layout
                                    path={[{ name: '行政管理設定', path: '' },
                                    { name: '環境基本資料管理', path: '' },
                                    { name: '教室維護', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/EnviornmentList': '環境維護',
                                            '/cramSchool/admin/ClassRoomList': '教室維護',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/EnviornmentList",
                                                label: `環境維護`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassRoomList",
                                            //     label: '教室維護',
                                            // },
                                        ]} />
                                    <ClassRoomList />
                                </Main_layout >} />
                                <Route path='EnviornmentList' element={<Main_layout
                                    path={[{ name: '行政管理設定', path: '' },
                                    { name: '環境基本資料管理', path: '' },
                                    { name: '環境維護', path: '' }]} >
                                    <ClassTab
                                        titles={{
                                            '/cramSchool/admin/EnviornmentList': '環境維護',
                                            '/cramSchool/admin/ClassRoomList': '教室維護',
                                        }}
                                        items={[
                                            {
                                                key: "/cramSchool/admin/EnviornmentList",
                                                label: `環境維護`,
                                            },
                                            // {
                                            //     key: "/cramSchool/admin/ClassRoomList",
                                            //     label: '教室維護',
                                            // },
                                        ]} />
                                    <EnviornmentList />
                                </Main_layout >} />
                                <Route path='AdminNews' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '最新消息公告', path: '' }]} >
                                    <Manage />
                                    <AdminNews />
                                </Main_layout >} />
                                <Route path='AdminClass' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '課程介紹內容管理', path: '' }]} >
                                    <Manage />
                                    <AdminClass />
                                </Main_layout >} />
                                <Route path='Maintain' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '形象介紹、聯絡資訊維護', path: '' }]} >
                                    <Manage />
                                    <Maintain />
                                </Main_layout >} />
                                <Route path='AdminTeacher' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '師資介紹內容管理', path: '' }]} >
                                    <Manage />
                                    <AdminTeacher />
                                </Main_layout >} />
                                <Route path='AdminEnviorment' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '環境介紹內容管理', path: '' }]} >
                                    <Manage />
                                    <AdminEnviorment />
                                </Main_layout >} />
                                <Route path='AdminTidbits' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '上課花絮內容管理', path: '' }]} >
                                    <Manage />
                                    <AdminTidbits />
                                </Main_layout >} />
                                <Route path='AdminShareLearning' element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '形象推廣管理模組', path: '' },
                                    { name: '學習見證內容管理', path: '' }]} >
                                    <Manage />
                                    <AdminShareLearning />
                                </Main_layout >} />
                                <Route path="ChatRoom" element={<Main_layout
                                    path={[{ name: '開課前', path: '' },
                                    { name: '線上聊天平台', path: '' }]}>
                                    <ChatRoom />
                                </Main_layout>} />
                                <Route path="Form" element={<Main_layout
                                    path={[{ name: '系統意見回饋表單', path: '' },
                                    { name: '系統意見回饋表單', path: '' }]}>
                                    <FeedBackTab />
                                    <FeedbackForm />
                                </Main_layout>} />
                                <Route path="FormList" element={<Main_layout
                                    path={[{ name: '系統意見回饋表單', path: '' },
                                    { name: '系統意見回饋表單列表', path: '' }]}>
                                    <FeedBackTab />
                                    <FeedbackFormList />
                                </Main_layout>} />
                                <Route path='PermissionsList' >
                                    <Route path='All' element={<Main_layout
                                        path={[{ name: '行政管理設定', path: '' },
                                        { name: '權限設定管理', path: '' },
                                        { name: '所有成員', path: '' }]} >
                                        <PermissionsList />
                                    </Main_layout >} />
                                    <Route path='Administration' element={<Main_layout
                                        path={[{ name: '行政管理設定', path: '' },
                                        { name: '權限設定管理', path: '' },
                                        { name: '行政端', path: '' }]} >
                                        <PermissionsList />
                                    </Main_layout >} />
                                    <Route path='Teacher' element={<Main_layout
                                        path={[{ name: '行政管理設定', path: '' },
                                        { name: '權限設定管理', path: '' },
                                        { name: '老師端', path: '' }]} >
                                        <PermissionsList />
                                    </Main_layout >} />
                                </Route>
                                <Route path='TeacherCourseManage'>
                                    <Route path='All' element={<Main_layout
                                        path={[{ name: '開課中', path: '' },
                                        { name: '教師調/補課管理', path: '' },]} >
                                        <AdminTeacherCourseManage />
                                    </Main_layout >} />
                                    <Route path='SwitchCourse' element={<Main_layout
                                        path={[{ name: '開課中', path: '' },
                                        { name: '教師調課管理', path: '' },]} >
                                        <AdminTeacherCourseManage />
                                    </Main_layout >} />
                                    <Route path='AddCourse' element={<Main_layout
                                        path={[{ name: '開課中', path: '' },
                                        { name: '教師補課管理', path: '' },]} >
                                        <AdminTeacherCourseManage />
                                    </Main_layout >} />
                                </Route>
                                <Route path='CourseOutline' element={<Main_layout
                                    path={[{ name: '開課中', path: '' },
                                    { name: '課程大綱簡介', path: '' },]} >
                                    <AdminCourseOutline />
                                </Main_layout >} />
                                <Route path='CourseList' element={<Main_layout
                                    path={[{ name: '開課中', path: '' },
                                    { name: '課程清單', path: '' },]} >
                                    <AdminCourseList />
                                </Main_layout >} />
                                <Route path='Appointment' element={<AdminAppointment />} />
                                <Route path={'LocationData'} element={<LocationData />} />
                                <Route path='PunchManagement'
                                    element={<Main_layout
                                        path={[{ name: '開課中', path: '' },
                                        { name: '打卡管理模組', path: '' },
                                        { name: '打卡總覽', path: '' },]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/PunchManagement': '打卡總覽',
                                                '/cramSchool/admin/PunchRecode': '上課打卡記錄',
                                                '/cramSchool/admin/ClassTimeSetting': '班級課程上課設定',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/PunchManagement",
                                                    label: '打卡總覽',
                                                },
                                                {
                                                    key: "/cramSchool/admin/PunchRecode",
                                                    label: '上課打卡記錄',
                                                },
                                                {
                                                    key: "/cramSchool/admin/ClassTimeSetting",
                                                    label: '班級課程上課設定',
                                                },
                                            ]} />
                                        <PunchOverview />
                                    </Main_layout >}
                                />
                                <Route path='PunchRecode'
                                    element={<Main_layout
                                        path={[
                                            { name: '開課中', path: '' },
                                            { name: '打卡管理模組', path: '' },
                                            { name: '上課打卡記錄', path: '' },
                                        ]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/PunchManagement': '打卡總覽',
                                                '/cramSchool/admin/PunchRecode': '上課打卡記錄',
                                                '/cramSchool/admin/ClassTimeSetting': '班級課程上課設定',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/PunchManagement",
                                                    label: '打卡總覽',
                                                },
                                                {
                                                    key: "/cramSchool/admin/PunchRecode",
                                                    label: '上課打卡記錄',
                                                },
                                                {
                                                    key: "/cramSchool/admin/ClassTimeSetting",
                                                    label: '班級課程上課設定',
                                                },
                                            ]} />
                                        <PunchRecode />
                                    </Main_layout >} />
                                <Route path='ClassTimeSetting'
                                    element={<Main_layout
                                        path={[{ name: '開課中', path: '' },
                                        { name: '打卡管理模組', path: '' },
                                        { name: '班級課程上課設定', path: '' }
                                            ,]} >
                                        <ClassTab
                                            titles={{
                                                '/cramSchool/admin/PunchManagement': '打卡總覽',
                                                '/cramSchool/admin/PunchRecode': '上課打卡記錄',
                                                '/cramSchool/admin/ClassTimeSetting': '班級課程上課設定',
                                            }}
                                            items={[
                                                {
                                                    key: "/cramSchool/admin/PunchManagement",
                                                    label: '打卡總覽',
                                                },
                                                {
                                                    key: "/cramSchool/admin/PunchRecode",
                                                    label: '上課打卡記錄',
                                                },
                                                {
                                                    key: "/cramSchool/admin/ClassTimeSetting",
                                                    label: '班級課程上課設定',
                                                },
                                            ]} />
                                        <ClassTimeSetting />
                                    </Main_layout >} />
                                <Route path='ClassStudentPunchDetail/:grade_class_id/:only_date'
                                    element={
                                        <Main_layout
                                            path={
                                                [
                                                    { name: '開課中', path: '' },
                                                    { name: '打卡管理模組', path: '' },
                                                    { name: '班級學生打卡情況', path: '' },
                                                ]}
                                        >
                                            <ClassStudentPunchDetail />
                                        </Main_layout >} />
                            </Route>
                            <Route path="admin/Media" element={<AdminMediaTab topic={'admin'} />} >
                                <Route path='News' element={
                                    <Main_layout
                                        path={[{ name: '形象推廣管理模組', path: '' },
                                        { name: '最新消息公告', path: '' },]} >
                                        <AdminMedia blog_type_name={'lastest'} />
                                    </Main_layout >}></Route>
                                <Route path='ClassIntroduce' element={
                                    <Main_layout
                                        path={[{ name: '形象推廣管理模組', path: '' },
                                        { name: '課程介紹內容管理', path: '' },]} >
                                        <AdminMedia blog_type_name={'lesson_category'} />
                                    </Main_layout>}></Route>
                                <Route path='Class' element={
                                    <Main_layout
                                        path={[{ name: '形象推廣管理模組', path: '' },
                                        { name: '上課花絮內容管理', path: '' },]} >
                                        <AdminMedia blog_type_name={'tidbits'} />
                                    </Main_layout>}></Route>
                                <Route path='ShareLearning' element={
                                    <Main_layout
                                        path={[{ name: '形象推廣管理模組', path: '' },
                                        { name: '學習見證內容管理', path: '' },]} >
                                        <AdminMedia blog_type_name={'learn_witness'} />
                                    </Main_layout>}></Route>
                                <Route path='Content/2' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '無框美學', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={2} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/3' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '兒童美語', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={3} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/4' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '國中初階', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={4} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/5' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '國中養成班', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={5} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/6' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '國高中進階班', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={6} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/266' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '櫃檯夥伴', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={266} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Content/269' element={
                                    <Main_layout
                                        path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                        { name: '師德', path: '' },]} >
                                        <AdminMediaContent classify_structure_type_id={269} />
                                    </Main_layout>
                                }></Route>
                                <Route path='Smartphone' element={
                                    <Main_layout
                                        path={[{ name: '手機暫存區', path: '' }]} >
                                        <MediaSmartphone />
                                    </Main_layout>
                                }></Route>
                                <Route path='Tag' element={
                                    <Main_layout
                                        path={[{ name: '標籤管理', path: '' }]} >
                                        <TagList />
                                    </Main_layout>
                                }></Route>
                                {/* <Route path='Content/:Id/:ParentId' element={
                                // <Main_layout
                                //     path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                //     ]} >
                                // </Main_layout>
                                <MediaContent />
                            }></Route> */}
                                <Route path='Content/:Id' element={
                                    // <Main_layout
                                    //     path={[{ name: '學習聚寶盒（題庫）', path: '' },
                                    //     ]} >
                                    //     </Main_layout>
                                    <MediaContent />
                                }></Route>
                                {/* 
                            <Route path='EnglishCourse' element={<AdminMediaContent />}></Route>
                            <Route path='VideoClass' element={<AdminMediaContent />}></Route>
                            <Route path='ForeignTest' element={<AdminMediaContent />}></Route>
                            <Route path='OthersTest' element={<AdminMediaContent />}></Route> */}
                            </Route>
                            <Route path="admin" element={<AdminCourseTab topic={'admin'} />} >
                                <Route path='CourseOutlineManage' element={<AdminCourseOutlineManage />}></Route>
                                <Route path='MakeUpCourseManage' element={<AdminMakeUpCourseManage />}></Route>
                                <Route path='CourseMaterial' element={<AdminCourseMaterial />}></Route>
                                <Route path='HomeWork' element={<AdminCourseMaterial />}></Route>
                                <Route path='Test' element={<AdminCourseMaterial />}></Route>
                                <Route path='CourseStudentOverview' element={<AdminCourseStudentOverview />}></Route>
                                <Route path='CourseStudentAttendanceOverview' element={<AdminCourseStudentAttendanceOverview />}></Route>
                                <Route path='CourseStudentAttendance' element={<AdminCourseStudentAttendance />}></Route>
                            </Route>
                        </Route>
                        <Route>
                            <Route path={'Punch/:state'} element={<PunchReservation mode="QRcodePunch" />} />
                            <Route path={'PunchReservation'} element={<PunchReservation />} />
                            <Route path={'PunchReservation/:state/:GradeClassId'} element={<PunchReservation />} />
                            <Route path={'PunchReservation'} element={<PunchReservation />} />
                            <Route path={'PunchOut/:state'} element={<PunchOut />} />
                            <Route path={'QRcodePunch/:PatrolLocationId'} element={<QRcodePunch />} />
                            <Route path={'QRcodePunch/:PatrolLocationId/:GradeClassId'} element={<QRcodePunch />} />
                            <Route path={'NotifyBind'} element={<NotifyBind />} />
                            <Route path={'NotifyBind/:code'} element={<NotifyBind />} />
                        </Route>
                    </Route>

                </>)}
                {/* <Route path="admin" element={<Sidebar topic={'admin'} />} >
            </Route> */}
            </Routes >
        </ConfigProvider >
    );
}
export default MainRoute;

const BackendPermissionLimit = ({

}) => {
    const routeParams = useParams()
    const navigate = useNavigate();
    const needReload = useRef(false)
    const location = useLocation()
    const [userPermissionData, setUserPermissionData] = useState(null)
    const getStaffDiverge = () => {
        axios
            .get('/permission_management/permission_manage_self', {

            })
            .then((response) => {
                let data = response.data?.data || []
                let first_data = data.find(ele => true)
                setUserPermissionData(first_data?.role_permission)
            })
            .finally(() => {
            })
    }
    const HasPermission = ({ locationPathname, permissions }) => {
        let hasPermission
        hasPermission = permissions.find((element) => { return element?.permission_url === locationPathname })
        let routeParamsArr = Object.keys(routeParams)

        if (routeParamsArr.length > 1) {
            hasPermission = permissions.find((element) => { return locationPathname.includes(element?.permission_url) })
        }

        if (!hasPermission && locationPathname != '/cramSchool') {
            console.log({ routeParamsArr, hasPermission, permissions })
            navigate('/cramSchool/admin')
        }
    }
    useEffect(() => {
        getStaffDiverge()

    }, [])
    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
    }, [userPermissionData])
    useEffect(() => {
        if (!!userPermissionData) {
            HasPermission({ locationPathname: location?.pathname, permissions: userPermissionData })
        }
        if (needReload.current === true) {
            getStaffDiverge()
        }
        if (location?.pathname === "/cramSchool/admin/PermissionsList/All") {
            needReload.current = true
        }
        else {
            needReload.current = false
        }

    }, [location])

    return <Outlet />

}

const JWT = ({

}) => {

    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }

            return config;
        },
        (error) => Promise.reject(error)
    );

    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )

    return <Outlet />
}
